import React from "react";

type Props = {
  horizontal?: number | string;
  vertical?: number | string;
  className?: string;
};

export const Space = ({ horizontal, vertical, className }: Props) => (
  <div
    style={{ width: horizontal, height: vertical, flexShrink: 0 }}
    className={className}
  />
);
